import { minutesToHoursMap } from './minutes-to-hours-map';
export const getDisplayTime = ({ interval, activeLanguage, }) => {
    const { startTime, endTime, displayStartEndTime } = interval;
    if (displayStartEndTime === null || displayStartEndTime === void 0 ? void 0 : displayStartEndTime[activeLanguage]) {
        return displayStartEndTime === null || displayStartEndTime === void 0 ? void 0 : displayStartEndTime[activeLanguage];
    }
    return `${minutesToHoursMap[startTime]} - ${minutesToHoursMap[endTime]}`;
};
